import ManageModal from './ManageModal'

export default ManageModal

export { ManageModal }
